import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoPassportCard24 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M19.0832 6.58333V17.4167C19.0832 17.8769 18.7101 18.25 18.2498 18.25H5.74984C5.2896 18.25 4.9165 17.8769 4.9165 17.4167L4.9165 6.58333C4.9165 6.12308 5.2896 5.75 5.74984 5.75H18.2498C18.7101 5.75 19.0832 6.12308 19.0832 6.58333Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M9.9165 15.3334H14.0832M14.0832 10.75C14.0832 11.9006 13.1504 12.8334 11.9998 12.8334C10.8493 12.8334 9.9165 11.9006 9.9165 10.75C9.9165 9.59943 10.8493 8.66669 11.9998 8.66669C13.1504 8.66669 14.0832 9.59943 14.0832 10.75Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoPassportCard24;